<template>
  <div
    class="layout--main"
    :class="[navbarClasses, footerClasses, { 'app-page': isAppPage }]">
    <!--<vx-tour :steps="steps" v-if="!disableThemeTour" />-->

    <!--        <the-customizer-->
    <!--            @updateNavbar="updateNavbar"-->
    <!--            @updateNavbarColor="updateNavbarColor"-->
    <!--            @updateTheme="updateTheme"-->
    <!--            :navbarType="navbarType"-->
    <!--            :navbarColor="navbarColor"-->
    <!--            :footerType="footerType"-->
    <!--            @updateFooter="updateFooter"-->
    <!--            :routerTransition="routerTransition"-->
    <!--            @updateRouterTransition="updateRouterTransition"-->
    <!--            v-if="!disableCustomizer"-->
    <!--            :hideScrollToTop="hideScrollToTop"-->
    <!--            @toggleHideScrollToTop="toggleHideScrollToTop"-->
    <!--            />-->
    <!--        <vx-sidebar :sidebarItems="sidebarItems" :logo="require('@/assets/images/logo/logo_only.png')" title="BITRACK" parent=".layout&#45;&#45;main" />-->

    <div
      id="content-area"
      :class="[contentAreaClass, { 'show-overlay': bodyOverlay }]">
      <div id="content-overlay"></div>

      <div class="content-wrapper">
        <the-navbar
          @validateData="validateData()"
          :navbarColor="navbarColor"
          :class="[
            { 'text-white': isNavbarDark && !isThemeDark },
            { 'text-base': !isNavbarDark && isThemeDark },
          ]" />

        <div class="router-view">
          <div
            class="router-content"
            :class="{ 'mt-0': navbarType == 'hidden' }">
            <transition :name="routerTransition">
              <div
                class="router-header flex flex-wrap items-center mb-6"
                v-if="
                  ($route.meta.breadcrumb || $route.meta.pageTitle) &&
                  $route.meta.pageTitle != 'Dashboard'
                ">
                <div
                  class="content-area__heading"
                  :class="{
                    'pr-4 border-0 md:border-r border-t-0 border-b-0 border-l-0 border-solid border-grey-light':
                      $route.meta.breadcrumb,
                  }">
                  <h2 class="mb-1">{{ $t(routeTitle) }}</h2>
                </div>
                <vx-breadcrumb
                  class="ml-4 md:block hidden"
                  v-if="$route.meta.breadcrumb" />
                <!--<vs-dropdown class="ml-auto md:block hidden cursor-pointer" vs-trigger-click>-->
                <!--<vs-button radius icon="icon-settings" icon-pack="feather"></vs-button>-->

                <!--<vs-dropdown-menu class="w-32">-->
                <!--<vs-dropdown-item><router-link to="/pages/profile" class="flex items-center"><feather-icon icon="UserIcon" class="inline-block mr-2" svgClasses="w-4 h-4" /><span>Profile</span></router-link></vs-dropdown-item>-->
                <!--<vs-dropdown-item><router-link to="/apps/todo" class="flex items-center"><feather-icon icon="CheckSquareIcon" class="inline-block mr-2" svgClasses="w-4 h-4" /><span>Tasks</span></router-link></vs-dropdown-item>-->
                <!--<vs-dropdown-item><router-link to="/apps/email" class="flex items-center"><feather-icon icon="MailIcon" class="inline-block mr-2" svgClasses="w-4 h-4" /><span>Inbox</span></router-link></vs-dropdown-item>-->
                <!--</vs-dropdown-menu>-->
                <!--</vs-dropdown>-->
              </div>
            </transition>
            <div class="content-area__content">
              <back-to-top
                bottom="5%"
                visibleoffset="500"
                v-if="!hideScrollToTop">
                <vs-button
                  icon-pack="feather"
                  icon="icon-arrow-up"
                  class="shadow-lg" />
              </back-to-top>
              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle"></router-view>
              </transition>
            </div>
          </div>
        </div>
      </div>

      <the-footer></the-footer>
    </div>
  </div>
</template>

<script>
import VxSidebar from '@/layouts/components/vx-sidebar/VxSidebar.vue'
import TheCustomizer from '../components/customizer/TheCustomizer.vue'
import TheNavbar from '../components/TheNavbar.vue'
import TheFooter from '../components/TheFooter.vue'
import themeConfig from '@/../themeConfig.js'
import sidebarItems from '@/layouts/components/vx-sidebar/sidebarItems.js'
import BackToTop from 'vue-backtotop'

const VxTour = () => import('@/components/VxTour.vue')
import * as REPO from '../../repository/index'
import * as moment from 'moment'
import firebase from 'firebase/app'
import 'firebase/database'

export default {
  data() {
    return {
      navbarType: themeConfig.navbarType || 'static',
      navbarColor: themeConfig.navbarColor || '#fff',
      footerType: themeConfig.footerType || 'static',
      routerTransition: themeConfig.routerTransition || 'none',
      isNavbarDark: false,
      userFirebase: false,
      menu_parent: [],
      counterAlert: '',
      routeTitle: this.$route.meta.pageTitle,
      sidebarItems: sidebarItems,
      disableCustomizer: themeConfig.disableCustomizer,
      waktuCek: null,
      windowWidth: window.innerWidth, //width of windows
      hideScrollToTop: themeConfig.hideScrollToTop,
      disableThemeTour: themeConfig.disableThemeTour,
      steps: [
        {
          target: '#btnSidebarToggler',
          content: 'Toggle Collapse Sidebar.',
        },
        {
          target: '.vx-navbar__starred-pages',
          content:
            'Create your own bookmarks. You can also re-arrange them using drag & drop.',
        },
        {
          target: '.i18n-locale',
          content: 'You can change language from here.',
        },
        {
          target: '.navbar-fuzzy-search',
          content: 'Try fuzzy search to visit pages in flash.',
        },
        {
          target: '.customizer-btn',
          content: 'Customize template based your preference',
          params: {
            placement: 'left',
          },
        },
      ],
    }
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle
      this.checkUserSession()
    },
    isThemeDark(val) {
      if (this.navbarColor == '#fff' && val) {
        this.updateNavbarColor('#10163a')
      } else {
        this.updateNavbarColor('#fff')
      }
    },
  },
  computed: {
    isAppPage() {
      if (this.$route.path.includes('/apps/')) return true
      else return false
    },
    isThemeDark() {
      return this.$store.state.theme == 'dark'
    },
    sidebarWidth() {
      return this.$store.state.sidebarWidth
    },
    bodyOverlay() {
      return this.$store.state.bodyOverlay
    },
    contentAreaClass() {
      return 'content-area-full'
      if (this.sidebarWidth == 'default') return 'content-area-default'
      else if (this.sidebarWidth == 'reduced') return 'content-area-reduced'
      else if (this.sidebarWidth) return 'content-area-full'
    },
    navbarClasses() {
      return {
        'navbar-hidden': this.navbarType == 'hidden',
        'navbar-sticky': this.navbarType == 'sticky',
        'navbar-static': this.navbarType == 'static',
        'navbar-floating': this.navbarType == 'floating',
      }
    },
    footerClasses() {
      return {
        'footer-hidden': this.footerType == 'hidden',
        'footer-sticky': this.footerType == 'sticky',
        'footer-static': this.footerType == 'static',
      }
    },
  },
  methods: {
    checkUserSession() {
      let self = this
      let user = JSON.parse(localStorage.getItem('userInfo'))
      if (user) {
        let param = {
          start_date: moment().format('YYYY-MM-DD') + ' 00:00:01',
          end_date: moment().format('YYYY-MM-DD') + ' 23:59:00',
          limit: 100,
          is_new: 1,
          fleet_group_id: user.id,
        }
        REPO.getAlertHistoryNotification(param)
          .then((res) => {
            // let data = res.data.data.data
            // self.$store.dispatch('addNotifData', data)
            // self.$store.dispatch('updateCounter', res.data.data.total)
            // self.$store.dispatch('notif/changeInitiate', true)
          })
          .catch((err) => {
            self.$vs.notify({
              duration: 5000,
              title: 'Error',
              text: 'User Session is Expired or someone is using this account on different device, Please Login Again',
              color: 'danger',
              position: 'bottom-right',
            })
            self.logout()
          })
      }
    },
    logout() {
      // let user_id = JSON.parse(localStorage.getItem('userInfo')).id
      // REPO.lgoutUser({ user_id }).then((res) => {
      // disconnect socket
      // socket.disconnect()
      // this.$auth.logOut()
      localStorage.removeItem('userInfo')
      localStorage.removeItem('userData')
      localStorage.removeItem('token')
      localStorage.removeItem('expired')
      this.$router.push('/pages/login')
      // Change role on logout. Same value as initialRole of acj.js
      // this.$acl.change('admin')
      localStorage.removeItem('userRole')
      // })
    },
    validateData() {
      let self = this
      let param = {
        start_date: moment().format('YYYY-MM-DD') + ' 00:00:01',
        end_date: moment().format('YYYY-MM-DD') + ' 23:59:00',
        limit: 100,
        is_new: 1,
        fleet_group_id: self.$dataLocal.UserData().id,
      }
      REPO.getAlertHistoryNotification(param).then((res) => {
        let data = res.data.data.data

        self.$store.dispatch('addNotifData', data)
        self.$store.dispatch('updateCounter', res.data.data.total)
        self.$store.dispatch('notif/changeInitiate', true)
      })
    },
    changeRouteTitle(title) {
      this.routeTitle = title
    },
    updateNavbar(val) {
      this.navbarType = val
      localStorage.setItem('navbar', val)
    },
    updateTheme(val) {
      localStorage.setItem('theme', val)
    },
    updateNavbarColor(val) {
      this.navbarColor = val
      if (val == '#fff') this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    updateFooter(val) {
      this.footerType = val
    },
    updateRouterTransition(val) {
      this.routerTransition = val
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth
      this.setSidebarWidth()
    },
    setSidebarWidth() {
      //
      if (this.windowWidth < 1200) {
        this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', false)
        this.$store.dispatch('updateSidebarWidth', 'no-sidebar')
        this.disableThemeTour = true
      } else if (this.windowWidth < 1200) {
        this.$store.dispatch('updateSidebarWidth', 'reduced')
      } else {
        this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', true)
      }
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val
    },
    signInFirebase() {
      firebase
        .auth()
        .signInAnonymously()
        .catch(function (error) {
          //
        })
    },
  },
  components: {
    VxSidebar,
    TheNavbar,
    TheFooter,
    TheCustomizer,
    BackToTop,
    VxTour,
  },
  mounted() {
    var self = this
    this.checkUserSession()
    var navb = localStorage.getItem('navbar')
    if (navb) {
      this.navbarType = navb
    }
    var themes = localStorage.getItem('theme')
    if (themes) {
      this.$store.dispatch('updateTheme', themes)
    }
    this.$root.$on('reloadNotifAtas', () => {
      //
      this.validateData()
    })
    REPO.getListMenu().then((res) => {
      let menus = JSON.parse(localStorage.getItem('userInfo')).role.role_menu
      let master_menu = res.data.data
      this.menu_data = []
      let tmp = [
        {
          url: '/',
          name: 'Dashboard',
          slug: 'dashboard',
          icon: 'HomeIcon',
          i18n: 'Dashboard',
        },
        {
          url: null,
          name: 'Master Data',
          slug: 'MasterData',
          icon: 'DatabaseIcon',
          i18n: 'MasterData',
          submenu: [
            {
              url: '/master-data/fleet-group',
              name: 'Fleet Gorup',
              slug: 'fleetGroup',
              i18n: 'FleetGroup',
            },
          ],
        },
      ]
      master_menu.forEach((x) => {
        let tmp = menus.filter((y) => {
          return x.id == y.menu_id
        })
        if (tmp.length > 0) {
          this.menu_data.push({
            url: x.menu_link,
            id: x.id,
            parent_id: x.parent_id,
            name: x.menu_name,
            slug: x.menu_name,
            icon: x.menu_icon,
            i18n: x.menu_name,
          })
        }
      })
      let hasil = this.menu_data.filter((x) => {
        return x.parent_id == ''
      })
      hasil.forEach((z) => {
        let tmp = this.menu_data.filter((x) => {
          return x.parent_id == z.id
        })
        if (tmp.length > 0) {
          z.url = null
          z.submenu = tmp
        }
      })
      this.menu_parent = hasil
      //
      //
      // let tmp = this.menu_data.filter(x=>{
      //     return x.parent_id == val.id;
      // });
      // return tmp;
    })
    firebase.auth().onAuthStateChanged(function (user) {
      //
      if (user) {
        //
        self.userFirebase = true
        //
        let ref = firebase
          .database()
          .ref('alert/' + self.$dataLocal.UserData().fleet_group_id)
        self.reff = ref
        ref.on(
          'value',
          function (snapshot) {
            let param = {
              start_date: moment().format('YYYY-MM-DD') + ' 00:00:01',
              end_date: moment().format('YYYY-MM-DD') + ' 23:59:00',
              limit: 10,
              is_new: 1,
              fleet_group_id: self.$dataLocal.UserData().id,
            }
            if (self.waktuCek == null) {
              //
              self.waktuCek = moment()
              REPO.getAlertHistoryNotification(param).then((res) => {
                let data = res.data.data.data

                self.$store.dispatch('addNotifData', data)
                self.$store.dispatch('updateCounter', res.data.data.total)
                self.$store.dispatch('notif/changeInitiate', true)
              })
            } else {
              let now = moment()
              let past = moment(self.waktuCek)
              let perbedaan = now.diff(past, 'seconds')
              //
              //

              if (Math.abs(parseInt(perbedaan)) > 60) {
                self.waktuCek = moment()
                //
                REPO.getAlertHistoryNotification(param).then((res) => {
                  let data = res.data.data.data

                  self.$store.dispatch('addNotifData', data)
                  self.$store.dispatch('updateCounter', res.data.data.total)
                  self.$store.dispatch('notif/changeInitiate', true)
                })
              }
            }

            // this.$store.dispatch('eCommerce/additemInCart', item)
            //
            let initiate = self.$store.getters['notif/isInitiate']()
            let allData = []
            // keys.forEach(x=>{
            //     let tmp = x.toString();
            //     // let check_ada = self.$store.getters['notif/isInAlertList'](tmp);
            //     // if(!check_ada){
            //     //     self.$store.dispatch('notif/addNotifNew',tmp);
            //     if(x!=='create_date')
            //         allData.push(data_firebase[x].body);
            //     // }
            //     // self.$store.dispatch('addCounter','1');
            //     // if(!check_ada && initiate){
            //     //     let license_plate = data_firebase[x].body.license_plate;
            //     //     let jenis_alert = data_firebase[x].body.alert;
            //     //     let jenis = 'danger';
            //     //     if(jenis_alert=='Over Speed'){
            //     //         jenis='danger';
            //     //     }else{
            //     //         jenis='warning';
            //     //     }
            //     //     let lokasi = data_firebase[x].body.lokasi;
            //     //
            //     //     self.$vs.notify({
            //     //         time: 5500,
            //     //         title: license_plate.toString(),
            //     //         text: "The Vehicle is "+jenis_alert.toString(),
            //     //         iconPack: 'feather',
            //     //         icon: 'icon-alert-circle',
            //     //         color: jenis,
            //     //         click:()=>{
            //     //             // self.$router.push('/monitoring-vehicle/'+license_plate);
            //     //             let win = window.open(lokasi, '_blank');
            //     //             win.focus();
            //     //         }
            //     //     });
            //     // }
            //
            // });
          },
          function (errorObject) {
            // ("The read failed: " + errorObject.code);
          }
        )
      } else {
        // User is signed out.
        // ...
        // ("sign out")
      }
      // ...
    })
    if (self.userFirebase) {
      let ref = firebase
        .database()
        .ref('tracking/' + this.$dataLocal.UserData().fleet_group_id)
      self.reff = ref
      ref.on(
        'value',
        function (snapshot) {
          //
          //
          //
        },
        function (errorObject) {
          //
        }
      )
    }
    this.signInFirebase()
  },
  created() {
    this.setSidebarWidth()
    if (this.navbarColor == '#fff' && this.isThemeDark) {
      this.updateNavbarColor('#10163a')
    } else {
      this.updateNavbarColor(this.navbarColor)
    }
  },
}
</script>
